import type { SaleManagementResponse } from "../types/sale-management";

export function getSaleIdentifier(sale: any): string {
  if (!sale) return "";
  if (sale.mongoId && typeof sale.mongoId === "string" && sale.mongoId.trim()) {
    return sale.mongoId.trim();
  }
  if (sale._id && /^[a-f0-9]{24}$/i.test(String(sale._id).trim())) {
    return String(sale._id).trim();
  }
  if (sale.id && /^[a-f0-9]{24}$/i.test(String(sale.id).trim())) {
    return String(sale.id).trim();
  }
  return String(sale._id ?? sale.id ?? "");
}

export function getSaleDisplayId(sale: any): string {
  if (!sale) return "";
  const id = String(sale.id ?? sale._id ?? "");
  return /^[a-f0-9]{24}$/i.test(id) ? id.slice(-6).toUpperCase() : id;
}

export function removeSaleFromList(sales: SaleManagementResponse[], removed: SaleManagementResponse): SaleManagementResponse[] {
  const identifier = getSaleIdentifier(removed);
  return sales.filter((sale) => getSaleIdentifier(sale) !== identifier);
}

function isSaleRecord(value: unknown): value is SaleManagementResponse {
  if (!value || typeof value !== "object") return false;
  const record = value as Record<string, unknown>;
  const hasId = typeof record.id === "string" || typeof record.id === "number" || typeof record._id === "string" || typeof record.mongoId === "string";
  return hasId && (
    record.eventType !== undefined ||
    record.plan !== undefined ||
    record.dataCollectionStatus !== undefined ||
    record.title !== undefined ||
    record.lang !== undefined
  );
}

export function unwrapSaleRecord(response: unknown): SaleManagementResponse {
  if (isSaleRecord(response)) return response;
  if (response && typeof response === "object" && "data" in response) {
    const data = (response as Record<string, unknown>).data;
    if (isSaleRecord(data)) return data;
    if (data && typeof data === "object" && "data" in data && isSaleRecord((data as Record<string, unknown>).data)) {
      return (data as Record<string, unknown>).data as SaleManagementResponse;
    }
    if (data && typeof data === "object" && (typeof (data as any).id === "string" || typeof (data as any).id === "number" || typeof (data as any)._id === "string" || typeof (data as any).mongoId === "string")) {
      return data as SaleManagementResponse;
    }
  }
  if (response && typeof response === "object" && (typeof (response as any).id === "string" || typeof (response as any).id === "number" || typeof (response as any)._id === "string" || typeof (response as any).mongoId === "string")) {
    return response as SaleManagementResponse;
  }
  throw new Error("Invalid sale response");
}
